'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.lineIntersection = exports.lineIntersectionPoints = undefined;

var _point = require('./point');

// Required to avoid javascript rounding errors
var ERROR_MARGIN = 0.1; // Geometry Utils


var pointIsOnLine = function pointIsOnLine(x, y, x1, y1, x2, y2) {
    var minX = Math.min(x1, x2);
    var maxX = Math.max(x1, x2);
    var minY = Math.min(y1, y2);
    var maxY = Math.max(y1, y2);

    return x >= minX - ERROR_MARGIN && x <= maxX + ERROR_MARGIN && y >= minY - ERROR_MARGIN && y <= maxY + ERROR_MARGIN;
};

// From http://pomax.github.io/bezierinfo/#intersections
var lineIntersectionAlgebra = function lineIntersectionAlgebra(x1, y1, x2, y2, x3, y3, x4, y4) {
    var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4);
    var ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4);
    var d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);

    if (d === 0) return null;

    var x = nx / d;
    var y = ny / d;

    return pointIsOnLine(x, y, x1, y1, x2, y2) && pointIsOnLine(x, y, x3, y3, x4, y4) ? (0, _point.getPoint)(x, y) : null;
};

var lineIntersectionPoints = exports.lineIntersectionPoints = function lineIntersectionPoints(l1Start, l1End, l2Start, l2End) {
    return lineIntersectionAlgebra(l1Start.x, l1Start.y, l1End.x, l1End.y, l2Start.x, l2Start.y, l2End.x, l2End.y);
};

var lineIntersection = exports.lineIntersection = function lineIntersection(line1, line2) {
    return lineIntersectionPoints(line1.start, line1.end, line2.start, line2.end);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/maths/geometry/intersection.js
// module id = 2277
// module chunks = 0